import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import DatePickerCustom from 'components/Common/DatePickerCustom';
import DropdownOption from 'components/Common/DropdownOption';
import DropdownStatus from 'components/Common/DropdownStatus';
import InputsRange from 'components/Common/InputsRange';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { COLORS_KEYWORD_NAVER_REGISTER_STATUS, COLORS_SECTION_KEYWORD, KEYWORD_NAVER_REGISTER_STATUS_OPTIONS, SECTION_KEYWORD, SECTION_KEYWORD_OPTIONS } from 'helpers/constans';
import { formatNumberWithCommas } from 'helpers/format';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import NestingFilter from 'pages/News/Components/NestingFilter';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../components/Common/TableContainer";
import { deleteKeywordNaverToBoostingKeywordMulti, getKeywordNavers as onGetKeywordNavers, postKeywordNaverToBoostingKeywordMulti } from "../../store/thunks";
import TooltipCustom from 'components/Common/TooltipCustom';
export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = 'daily_search_volume';

registerLocale('en', en);
registerLocale('ko', ko);


const KeywordNaver = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const KEYWORD_NAVER_REGISTER_STATUS_OPTIONS_LANG = KEYWORD_NAVER_REGISTER_STATUS_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));


  const SECTION_KEYWORD_OPTIONS_LANG = SECTION_KEYWORD_OPTIONS?.filter((item: any) => String(item?.value) !== String(SECTION_KEYWORD.GOOGLE_TREND))?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 500),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    order_by: withDefault(StringParam, 'DESC'),
    // date: withDefault(StringParam, moment().format("Y-MM-DD")),
    // date_start: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    // date_end: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    keyword: withDefault(StringParam, ''),
    daily_search_volume_start: withDefault(StringParam, ''),
    daily_search_volume_end: withDefault(StringParam, ''),
    // count_start: withDefault(StringParam, ''),
    // count_end: withDefault(StringParam, ''),
    news_section_rank_start: withDefault(StringParam, ''),
    news_section_rank_end: withDefault(StringParam, ''),
    section: withDefault(StringParam, ''),
    register_status: withDefault(StringParam, ''),
  });

  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");

  const [startDailyVolumeSearch, setStartDailyVolumeSearch] = useState<string>(query?.daily_search_volume_start || "");
  const [endDailyVolumeSearch, setEndDailyVolumeSearch] = useState<string>(query?.daily_search_volume_end || "");

  const [startMentionSearch, setStartMentionSearch] = useState<string>(query?.count_start || "");
  const [endMentionSearch, setEndMentionSearch] = useState<string>(query?.count_end || "");

  const [startNewsSectionSearch, setStartNewsSectionSearch] = useState<string>(query?.news_section_rank_start || "");
  const [endNewsSectionSearch, setEndNewsSectionSearch] = useState<string>(query?.news_section_rank_end || "");

  const [sectionSearch, setSectionSearch] = useState<Option | null>(SECTION_KEYWORD_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.section)) || null);

  const [registerStatusSearch, setRegisterStatusSearch] = useState<Option | null>(KEYWORD_NAVER_REGISTER_STATUS_OPTIONS_LANG?.find((item) => String(item?.value) === String(query?.register_status)) || null);

  const [dateSearch, setDateSearch] = useState<any>(query?.date ? moment(query?.date, 'Y-MM-DD').toDate() : null);

  const [dateRangeSearch, setDateRangeSearch] = useState<any[]>([query?.date_start ? moment(query?.date_start, 'Y-MM-DD').toDate() : null, query?.date_end ? moment(query?.date_end || '', 'Y-MM-DD').toDate() : null]);
  const [startDate, endDate] = dateRangeSearch;

  const [isOpenConfirmChangeStatusMulti, setIsOpenConfirmChangeStatusMulti] = useState<"ADD_TO_BOOSTING_KEYWORD" | "EXCLUDE_FROM_BOOSTING_KEYWORD" | false>(false);

  const [optionsSelected, setOptionsSelected] = useState<any>([]);

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.Keyword;

  const KeywordProperties = createSelector(
    selectLayoutState,
    (state) => ({
      keywordNavers: state.keywordNavers,
      isKeywordNaverSuccess: state.isKeywordNaverSuccess,
      isKeywordNaverLoading: state.isKeywordNaverLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { keywordNavers, error, isKeywordNaverLoading } = useSelector(KeywordProperties);

  useEffect(() => {
    dispatch(onGetKeywordNavers(query));
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    if (isKeywordNaverLoading) {
      return;
    }
    setOptionsSelected((prev: any) => []);
    const queryNew = {
      ...query,
      keyword: keywordSearch || '',
      section: sectionSearch?.value,
      // date: dateSearch ? moment(new Date(dateSearch)).format("Y-MM-DD") : '',
      // date_start: startDate ? moment(new Date(startDate)).format("Y-MM-DD") : '',
      // date_end: endDate ? moment(new Date(endDate)).format("Y-MM-DD") : '',
      daily_search_volume_start: startDailyVolumeSearch || '',
      daily_search_volume_end: endDailyVolumeSearch || '',
      // count_start: startMentionSearch || '',
      // count_end: endMentionSearch || '',
      news_section_rank_start: startNewsSectionSearch || '',
      news_section_rank_end: endNewsSectionSearch || '',
      register_status: registerStatusSearch?.value,
      page: 1,
      time_request: + new Date()
    };
    setQuery(queryNew);
  };

  const resetData = () => {
    const queryNew = {
      ...query,
      keyword: '',
      section: '',
      daily_search_volume_start: '',
      daily_search_volume_end: '',
      // count_start: '',
      // count_end: '',
      news_section_rank_start: '',
      news_section_rank_end: '',
      register_status: '',
      order_by: 'DESC',
      sort_by: TYPE_SELECT_DEFAULT,
      // date: `${moment().format("Y-MM-DD")}`,
      // date_start: `${moment().format("Y-MM-DD")}`,
      // date_end: `${moment().format("Y-MM-DD")}`,
      time_request: + new Date(),
      page: 1,
    };
    setQuery(queryNew, "push");
    setKeywordSearch((_prev) => "");
    setRegisterStatusSearch(null);
    setSectionSearch(null);
    setStartDailyVolumeSearch(queryNew?.daily_search_volume_start);
    setEndDailyVolumeSearch(queryNew?.daily_search_volume_end);
    // setStartMentionSearch(queryNew?.count_start);
    // setEndMentionSearch(queryNew?.count_end);
    setStartNewsSectionSearch(queryNew?.news_section_rank_start);
    setEndNewsSectionSearch(queryNew?.news_section_rank_end);
    // setDateSearch(moment(queryNew?.date || "", 'Y-MM-DD').toDate());
    // setDateRangeSearch([moment(queryNew?.date_start || "", 'Y-MM-DD').toDate(), moment(queryNew?.date_end || "", 'Y-MM-DD').toDate()]);
  };
  //End::Update User

  // Begin:: handle select table 
  const handleCheck = (valueCheck: Option, valueIndex: number | string, e: any = null) => {

    const index = String(valueIndex);
    if (valueCheck?.value === 'ALL') {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (e.target.checked) {
          if (prevClone[index] === undefined) {
            prevClone[index] = [];
          }
          prevClone[index] = (keywordNavers?.list || [])?.map((item: any) => ({ value: item?.id, label: item?.id }));
          return prevClone;
        } else {
          prevClone[index] = [];
          return prevClone;
        }
      });
      return;
    }
    if (!e.target.checked) {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (prevClone[index] === undefined) {
          prevClone[index] = [];
        }
        prevClone[index] = (prevClone[index] || [])?.filter((item: any) => (item?.value !== valueCheck?.value));
        return prevClone;
      });
    } else {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (prevClone[index] === undefined) {
          prevClone[index] = [];
        }
        prevClone[index] = ([...prevClone[index], valueCheck]);
        return prevClone;
      });
    }
  };

  const isChecked = (valueCheck: Option) => {
    const index = String(query.page);
    return !!(optionsSelected[index]?.find((x: any) => x.value === valueCheck?.value)?.value);
  };

  const isCheckedAll = (valueIndex: string) => {
    const valueIndexString = String(valueIndex);
    return (optionsSelected[valueIndexString]?.length > 0 && optionsSelected[valueIndexString]?.length === keywordNavers?.list?.length);
  };

  const countRowSelected = useMemo(() => {
    return Object.entries(optionsSelected)?.reduce((total: number, [key, value]: any) => {
      return Number(total + (value || [])?.length);
    }, 0)
  }, [optionsSelected]);

  // End:: handle select table 

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t('Key'),
        accessor: "",
        filterable: true,
        sortable: false,
        thClass: 'text-start align-middle',
        thWidth: 50,
        thComponent: () => (<>
          <div className="form-check">
            <input className="form-check-input" type="checkbox" checked={isCheckedAll(query?.page)} onChange={(e) => handleCheck(({ value: 'ALL', label: '' }), query?.page, e)} value="" id={`cell-check-all`} />
            <label className="form-check-label" htmlFor={`cell-check-all`}></label>
          </div>
        </>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          const __id = item?.id;
          return (
            <>
              <div className={`form-check`}>
                <input className="form-check-input" type="checkbox" name="table" checked={isChecked({ value: __id, label: __id })} value={__id ?? ''} onChange={(e) => handleCheck(({ value: __id, label: __id }), query?.page, e)} id={`cell-check-${__id ?? ''}`} />
                <label className="form-check-label" htmlFor={`cell-check-${__id ?? ''}`}></label>
              </div>
            </>
          )
        },
      },
      {
        Header: t('ID'),
        accessor: "id",
        filterable: true,
        sortable: false,
        thWidth: 80,
        thClass: 'text-start align-middle',
        Cell: (cell: any) => (
          <>
            <span style={{ minWidth: '50px' }}>{cell?.value}</span>
          </>
        ),
      },
      {
        Header: t('Keyword'),
        accessor: "keyword",
        filterable: true,
        sortable: true,
        thWidth: 180,
        thClass: 'text-start align-middle',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="d-flex justify-content-between align-items-center cursor-pointer" style={{ maxWidth: '180px' }}>
              {cell?.value}
              <div>
                {!!item?.keyword_boosting && (!!item?.keyword_boosting?.is_excluded ?
                  <TooltipCustom
                    title={t("Exclude Keyword")}
                    className="d-inline-block vertical-align-middle"
                    style={{ transform: 'translateY(1px)' }}
                  >
                    <i className="bx bx-minus-circle text-danger fs-20" />
                  </TooltipCustom>
                  :
                  <TooltipCustom
                    title={t("Boosting Keyword")}
                    className="d-inline-block vertical-align-middle"
                    style={{ transform: 'translateY(1px)' }}
                  >
                    <i className="bx bx-check-circle text-success fs-20" />
                  </TooltipCustom>
                )}
              </div>
            </div>
          </>)
        },
      },
      {
        Header: '',
        accessor: "__",
        filterable: true,
        sortable: true,
        thWidth: 40,
        thClass: 'text-start align-middle',
        Cell: (cell: any) => {
          return (<></>)
        },
      },
      {
        Header: t('Sections'),
        accessor: "sections",
        filterable: true,
        sortable: false,
        thWidth: 250,
        thClass: 'align-middle text-start',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div style={{ minWidth: '150px' }} className="text-start d-flex flex-wrap justify-content-start align-items-center gap-2 fs-16">
              {(item?.sections || [])?.map((s: any) => (
                <span key={s} className={`badge bg-${COLORS_SECTION_KEYWORD[`${s || ''}`] || 'success'}-subtle text-${COLORS_SECTION_KEYWORD[`${s || ''}`] || 'success'}`}>
                  {SECTION_KEYWORD_OPTIONS_LANG?.find((ss) => String(ss?.value) === String(s))?.label || ''}
                </span>
              ))}
            </div>
          )
        },
      },
      {
        Header: t('Daily Search Volume'),
        accessor: "daily_search_volume",
        filterable: true,
        sortable: true,
        thClass: 'text-end align-middle',
        thWidth: i18n?.language === 'en' ? 180 : 140,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="pe-3 text-end" style={{ minWidth: i18n?.language === 'en' ? '160px' : '120px' }}>{formatNumberWithCommas(cell?.value)}</div>
          </>)
        },
      },
      // {
      //   Header: t('Mentions'),
      //   accessor: "count",
      //   filterable: true,
      //   sortable: true,
      //   thClass: 'text-end align-middle',
      //   thWidth: 120,
      //   description: t('The total number of mentions in the Naver headline news body on the specified date.'),
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     return (<>
      //       <div className="pe-info text-end" style={{ minWidth: '100px' }}>{formatNumberWithCommas(cell?.value)}</div>
      //     </>)
      //   },
      // },
      {
        Header: t('News Section'),
        accessor: "news_section_rank",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-end',
        description: t('The ranking of the news section in Naver search results for the keyword.'),
        thWidth: i18n?.language === 'en' ? 150 : 140,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '120px' }} className="text-end pe-info">
            {item?.news_section_rank ?? '-'}
          </div>)
        },
      },
      {
        Header: t('Created At'),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: i18n?.language === 'en' ? 130 : 120,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: i18n?.language === 'en' ? '110px' : '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Updated at'),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: i18n?.language === 'en' ? 110 : 100,
        thClass: 'text-end align-middle',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end" style={{ minWidth: i18n?.language === 'en' ? '90px' : '80px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
    ],
    [i18n?.language, query, userPermissions, JSON.stringify(optionsSelected), keywordNavers?.pagination?.total]
  );

  // Begin::Update status
  const handleConfirmChangeStatusMulti = (type_status: "ADD_TO_BOOSTING_KEYWORD" | "EXCLUDE_FROM_BOOSTING_KEYWORD") => {
    setIsOpenConfirmChangeStatusMulti((_prev) => type_status);
  };

  const handleActionChangeStatus = async () => {
    try {
      setIsConfirmLoading((_prev) => true);
      const kw_s = (optionsSelected || []).flat()?.map((item: any) => item?.value);
      const response: any = await (isOpenConfirmChangeStatusMulti === 'ADD_TO_BOOSTING_KEYWORD' ? postKeywordNaverToBoostingKeywordMulti({ ids: kw_s }) : deleteKeywordNaverToBoostingKeywordMulti({ ids: kw_s }));
      if (response?.code === 200) {
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
        dispatch(onGetKeywordNavers(query));
        setIsConfirmLoading((_prev) => false);
        setIsOpenConfirmChangeStatusMulti((_prev) => false);
        setOptionsSelected((prev: any) => []);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsOpenConfirmChangeStatusMulti((_prev) => false);
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmChangeStatusMultiClick = () => {
    setIsOpenConfirmChangeStatusMulti((_prev) => false);
  }
  // End::Update status

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy });
    });
  }, []);

  const changeLimitPerPage = (limit: number) => {
    if (String(limit) === String(query?.limit)) {
      return;
    }
    const queryNew = {
      ...query,
      limit: limit,
      time_request: + new Date(),
      page: 1,
    };
    setQuery(queryNew, "push");
    setOptionsSelected((prev: any) => []);
  };


  const handleChangeDatePicker = (date: any) => {
    setDateSearch((_prev: any) => date);
  }

  const handleChangeDateRangePicker = (values: any[] = []) => {
    setDateRangeSearch((_prev: any) => values);
  }

  const handelChangeSection = (section_search: Option) => {
    const queryNew = {
      ...query,
      section: section_search?.value,
      page: 1,
      time_request: + new Date()
    };
    setQuery(queryNew);
  }

  const handleCallAllOption = async () => {
    try {
      // const [res]: any = await Promise.all([getAllCategory()]);
      // const list = res?.data || [];
      // setListCategory((_prev) => list);
    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Home')} - ${t('Naver News Keywords')} | PRESS Ai`;

    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Naver News Keywords')} pageTitle={t('Home')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_NAVER_LIST, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }} className="ribbon-box right">
                  <div className="ribbon round-shape" style={{ top: '11px', background: 'rgb(40 99 213)', fontWeight: 300, fontSize: '0.8rem' }}>{t('This data is analyzed every hour2')}</div>
                  <CardHeader className="border-0" style={{ borderRadius: '30px' }}>
                    <Row className="g-4 align-items-center">
                      <div className="col-lg-12 mt-5 mt-sm-4">
                        <div>
                          <h5 className="card-title mb-0 mt-2 mt-sm-4 mt-lg-0 d-flex flex-column flex-sm-row gap-1 gap-sm-0">
                            <div>
                              <span className="me-2">{t('Total')}:</span>
                              {(isKeywordNaverLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={keywordNavers?.pagination?.total || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </div>
                            <div>
                              <span className="mx-2 text-muted d-none d-sm-inline-block">|</span>
                              <span>
                                <span className="me-2">{t('Boosting Keyword (N)')}:</span>
                                {(isKeywordNaverLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                  start={0}
                                  end={Number(keywordNavers?.pagination?.total || 0) - Number(keywordNavers?.total?.register_count || 0)}
                                  duration={1}
                                  className="text-primary"
                                />)}
                              </span>
                            </div>
                            <div>
                              <span className="mx-2 text-muted d-none d-sm-inline-block">|</span>
                              <span>
                                <span className="me-2">{t('Boosting Keyword (Y)')}:</span>
                                {(isKeywordNaverLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                  start={0}
                                  end={keywordNavers?.total?.register_count || 0}
                                  duration={1}
                                  className="text-primary"
                                />)}
                              </span>
                            </div>
                          </h5>
                        </div>
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-0 pb-md-4 px-0 px-lg-3 pt-0 pt-lg-3">
                    <NestingFilter>
                      <Row className="g-4 align-items-center mt-0">
                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                            <Input
                              type="text"
                              className="form-control search"
                              placeholder={`${t('Keyword')}...`}
                              value={keywordSearch}
                              onChange={(e) => setKeywordSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  searchData();
                                }
                              }}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={6} md={6} lg={6} xl={6} xxl={2} className='mt-3 mt-xxl-2'>
                          <LabelWrapper label={t('Boosting Keyword')} isShow={true}>
                            <DropdownStatus
                              name="rank"
                              dataList={KEYWORD_NAVER_REGISTER_STATUS_OPTIONS_LANG || []}
                              placeholder={`${t("Boosting Keyword")}...`}
                              className="dropdown-status-rounded z-hight"
                              classNamePrefix="name-prefix"
                              initialValue={registerStatusSearch || null}
                              onChangeSelect={(e: any) => setRegisterStatusSearch(e)}
                              isHasOptionAll={true}
                              optionAll={{ label: t('All'), value: '' }}
                              colors={COLORS_KEYWORD_NAVER_REGISTER_STATUS}
                            />
                          </LabelWrapper>
                        </Col>
                        <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-xxl-2' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startDailyVolumeSearch}
                            valueTo={endDailyVolumeSearch}
                            placeholderFrom={`${t('Daily Search Volume (Start)')}...`}
                            placeholderTo={`${t('Daily Search Volume (End)')}...`}
                            labelFrom={`${t('Daily Search Volume (Start)')}`}
                            labelTo={`${t('Daily Search Volume (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartDailyVolumeSearch(val)}
                            onChangeTo={(val) => setEndDailyVolumeSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>
                        {/* <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-xxl-2' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startMentionSearch}
                            valueTo={endMentionSearch}
                            placeholderFrom={`${t('Mentions (Start)')}...`}
                            placeholderTo={`${t('Mentions (End)')}...`}
                            labelFrom={`${t('Mentions (Start)')}`}
                            labelTo={`${t('Mentions (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartMentionSearch(val)}
                            onChangeTo={(val) => setEndMentionSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col> */}
                        <Col sm={12} md={6} lg={6} xl={6} xxl={4} className='mt-3 mt-xxl-2' >
                          <InputsRange
                            nameFrom="from"
                            nameTo="to"
                            valueFrom={startNewsSectionSearch}
                            valueTo={endNewsSectionSearch}
                            placeholderFrom={`${t('News Section (Start)')}...`}
                            placeholderTo={`${t('News Section (End)')}...`}
                            labelFrom={`${t('News Section (Start)')}`}
                            labelTo={`${t('News Section (End)')}`}
                            isTypeNumber={true}
                            onChangeFrom={(val) => setStartNewsSectionSearch(val)}
                            onChangeTo={(val) => setEndNewsSectionSearch(val)}
                            onKeyDownFrom={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                            onKeyDownTo={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </Col>

                        {/* <Col sm={6} md={6} lg={6} xl={6} xxl={4} className='date-picker-wrapper-custom mt-3'>
                          <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                            <DatePickerCustom
                              placeholder={`${t('Start Date')} - ${t('End Date')}`}
                              startDate={startDate || null}
                              endDate={endDate || null}
                              onChangePicker={handleChangeDateRangePicker}
                              showOptions={[
                                'today', 'yesterday', 'two_day_ago',
                                'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                'this_week', 'last_week',
                                'this_month', 'last_month',
                              ]}
                            />
                          </LabelWrapper>
                        </Col> */}
                        <Col sm={6} md={12} lg={12} xl={12} xxl={12} className="hstack gap-1 justify-content-center justify-content-sm-end mt-3">
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary me-2 "
                              onClick={searchData}
                              disabled={isKeywordNaverLoading}
                            >
                              <i className="ri-search-line align-bottom me-1"></i>{" "}
                              {t('Button Search')}
                            </button>
                            <button
                              type="button"
                              className="btn btn-secondary fs-14"
                              onClick={resetData}
                            >
                              <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                              {t('Button Reset')}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </NestingFilter>
                  </div>
                  <div className="border border-dashed border-top-0 border-end-0 border-start-0 px-3 py-3">
                    <Col sm={12} md={12} xl={12} xxl={12} className="mb-3 mb-lg-4">
                      <div>
                        <div className="d-flex gap-2 flex-wrap">
                          <button type="button" className={`btn px-3 px-md-4 py-btn-section ${String(query?.section) === '' ? 'bg-primary text-white' : 'border-gray text-secondary'}`}
                            onClick={(e) => { e.preventDefault(); handelChangeSection({ label: t('All'), value: '' }) }}
                          >
                            {t('All')}
                          </button>
                          {SECTION_KEYWORD_OPTIONS_LANG?.map((item) => (
                            <button type="button" className={`btn px-3 px-md-4 py-btn-section ${String(query?.section) === String(item?.value) ? `bg-primary text-white` : `border-gray text-secondary`}`} key={item?.value}
                              onClick={(e) => { e.preventDefault(); handelChangeSection(item) }}
                            >
                              {item?.label}
                            </button>
                          ))}
                        </div>
                      </div>
                    </Col>
                    <Col sm={12} md={12} xl={12} className="my-0 mt-4 mt-xxl-0 text-start d-flex flex-wrap gap-3 justify-content-between align-items-center">
                      <div>
                        {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_NAVER_UPDATE, userPermissions) &&
                          <button
                            type="button"
                            className="btn btn-soft-primary me-3 mb-2 mb-sm-0"
                            style={{ width: i18n?.language === 'en' ? '200px' : '150px' }}
                            disabled={countRowSelected <= 0}
                            onClick={(e) => { e.stopPropagation(); handleConfirmChangeStatusMulti('ADD_TO_BOOSTING_KEYWORD') }}
                          >
                            {countRowSelected > 0 && (
                              <span
                                className="position-absolute topbar-badge badge rounded-pill bg-danger"
                                style={{ transform: "translate(0%, -70%)" }}
                              >
                                {formatNumberWithCommas(countRowSelected)}
                                <span className="visually-hidden">
                                  total keywords selected
                                </span>
                              </span>
                            )}
                            {t('Add to Boosting Keyword')}
                          </button>
                        }
                        {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_NAVER_UPDATE, userPermissions) &&
                          <button
                            type="button"
                            className="btn btn-soft-danger me-3"
                            style={{ width: i18n?.language === 'en' ? '250px' : '150px' }}
                            disabled={countRowSelected <= 0}
                            onClick={(e) => { e.stopPropagation(); handleConfirmChangeStatusMulti('EXCLUDE_FROM_BOOSTING_KEYWORD') }}
                          >
                            {countRowSelected > 0 && (
                              <span
                                className="position-absolute topbar-badge badge rounded-pill bg-danger"
                                style={{ transform: "translate(0%, -70%)" }}
                              >
                                {formatNumberWithCommas(countRowSelected)}
                                <span className="visually-hidden">
                                  total keywords selected
                                </span>
                              </span>
                            )}
                            {t('Exclude from Boosting Keyword')}
                          </button>
                        }
                      </div>
                      <div className="">
                        <LabelWrapper label={t('Showcase')} isShow={true}>
                          <DropdownOption
                            name="showcase"
                            dataList={[{ label: '30', value: '30' }, { label: '50', value: '50' }, { label: '100', value: '100' }, { label: '500', value: '500' }]}
                            placeholder={`${t("Showcase")}...`}
                            className={`dropdown-status-rounded z-hight-100`}
                            classNamePrefix="name-prefix"
                            style={{ width: '85px' }}
                            initialValue={{ label: `${query?.limit}`, value: `${query?.limit}` }}
                            onChangeSelect={(e: any) => {
                              changeLimitPerPage(e?.value);
                            }}
                          />
                        </LabelWrapper>
                      </div>
                    </Col>
                  </div>
                  <CardBody className="pt-3">
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle sticky-table-keyword-naver"
                      theadClass="table-light"
                      columns={columns}
                      data={keywordNavers?.list?.length ? keywordNavers?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={keywordNavers?.pagination?.total}
                      customPageCount={Math.ceil(Number(keywordNavers?.pagination?.total) / Number(keywordNavers?.pagination?.limit))}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isKeywordNaverLoading}
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <ModalConfirm
          header={isOpenConfirmChangeStatusMulti === "ADD_TO_BOOSTING_KEYWORD" ? t('Add to Boosting Keyword') : t('Exclude from Boosting Keyword')}
          textButtonConfirm={isOpenConfirmChangeStatusMulti === "ADD_TO_BOOSTING_KEYWORD" ? t('Add to Boosting Keyword') : t('Exclude from Boosting Keyword')}
          classButtonConfirm={isOpenConfirmChangeStatusMulti === "ADD_TO_BOOSTING_KEYWORD" ? 'btn-soft-primary' : 'btn-soft-danger'}
          title={isOpenConfirmChangeStatusMulti === "ADD_TO_BOOSTING_KEYWORD" ? t("Are you sure you want to add to the Boosting Keyword?") : t("Are you sure you want to exclude from the Boosting Keyword?")}
          content={t("After confirming the update action, the data will be updated. Do you want to proceed with the update action.")}
          isOpen={!!isOpenConfirmChangeStatusMulti}
          classIconButtonConfirm=''
          isShowIcon={false}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmChangeStatusMultiClick}
          onConfirm={handleActionChangeStatus}
        />

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default KeywordNaver;
